
<template>
  <div class="static-height-container">
    <slot></slot>
  </div>
</template>

<script>
	export default {
    name: 'static-height-container',
		components: {
		},
    props: [

    ],
    methods: {
      
    },
    created() {
      
    },
    mounted() {
     
    }
}
</script>

<style scoped>
  .static-height-container{
    position:static;
    width:100%;
    height:100vh;
  }

</style>



// WEBPACK FOOTER //
// src/components/containers/static-height-container.vue